const truncate = (string: string, limit: number, useWordBoundary = true) => {
  if (string.length <= limit) {
    return string;
  }
  const subString = string.substr(0, limit - 1);
  return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '&hellip;';
};

export { truncate };
